// extracted by mini-css-extract-plugin
module.exports = {"switch":"DefaultSwitch_switch_2CDBu","disabled":"DefaultSwitch_disabled_DfrFB","slider":"DefaultSwitch_slider_2bDT8","rounded":"DefaultSwitch_rounded_3IX6k"};